/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';

export class QueryParamsHelper {

  /**
   * Construct HttpHeaders from QueryParams
   *
   * @param qp QueryParams
   *
   * @return HttpHeaders
   */
  static getHttpHeaders(qp?: QueryParams): HttpHeaders {
    let headers = new HttpHeaders();

    if (qp && qp.token) {
      headers = headers.append('Authorization', 'Bearer ' + qp.token);
    }

    if (qp && qp.version) {
      headers = headers.append('Accept', 'application/json;version=' + qp.version);
    } else {
      headers = headers.append('Accept', 'application/json;version=' + environment.api.version);
    }

    headers = headers.append('Content-Type', 'application/json');

    return headers;
  }

  /**
   * Construct HttpParams from QueryParams
   *
   * @param qp QueryParams
   *
   * @return HttpParams
   */
  static getHttpParams(qp?: QueryParams): HttpParams {
    let params = new HttpParams();

    if (qp && qp.filter) {
      params = params.append('filter', JSON.stringify(qp.filter));
    }

    if (qp && qp.perPage) {
      params = params.append('per-page', JSON.stringify(qp.perPage));
    }

    if (qp && qp.page) {
      params = params.append('page', JSON.stringify(qp.page));
    }

    if (qp && qp.serializerGroups) {
      params = params.append('serializer-groups', JSON.stringify(qp.serializerGroups));
    }

    if (qp && qp.sort) {
      params = params.append('sort', JSON.stringify(qp.sort));
    }

    return params;
  }

}

export interface QueryParams {
  filter?: any | string;
  perPage?: number;
  page?: number;
  serializerGroups?: string[] | string;
  sort?: Sort[] | string;
  token?: string;
  version?: number;
}

export interface Sort {
  desc: boolean;
  selector: string;
}

